import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SettingsBloc } from '@kbloc';
import { Setting } from '@ktypes/models';
import { MockComponent } from '@kutil/test';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslationBloc } from '../../translation.bloc';

@Component({
  selector: 'kf-loc-language-dropdown',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
})
export class LanguageDropdownComponent {
  constructor(
    public settingsBloc: SettingsBloc,
    public translationBloc: TranslationBloc
  ) {}

  @Input() showIcon = false;
  @Output() languageChanged = new EventEmitter<string>();

  onLanguageChange(selectedOption: EventTarget) {
    const language = (selectedOption as HTMLOptionElement).value;
    this.translationBloc.changeLanguage(language);
    this.settingsBloc.changeUserSetting(Setting.language, language);
    this.languageChanged.emit(language);
  }
}

export const MockLanguageDropdownComponent = MockComponent({
  selector: 'kf-loc-language-dropdown',
  inputs: ['showIcon'],
});
